import { useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import { Row, FieldDropdown, Group } from '@/components/form'
import useBasic from '@/hooks/use-basic'
import { getBankName, formatObfuscatedAccountNumber } from '@/features/Pad'

const DepositAccountField = ({ isRequired, accountData }) => {
  const { t } = useTranslation()
  const { setFieldValue } = useFormikContext()
  const { financial_institutions } = useBasic(['financial_institutions'])

  const accounts = useCallback(
    [accountData.financial_info].flat().map(e => {
      return {
        value: `${e.account_number}-${e.account_type}-${e.financial_institution_name}`,
        label: `${getBankName(
          e.financial_institution_name,
          financial_institutions
        )} - ${formatObfuscatedAccountNumber(e.account_number)}`
      }
    }),
    [accountData.financial_info]
  )

  useEffect(() => {
    setFieldValue('deposit_account', accounts[0].value)
  }, [setFieldValue, accounts])

  if (!accountData || !accountData.financial_info)
    return (
      <Row>
        <Group>
          <FieldDropdown
            id="deposit_account"
            name="deposit_account"
            placeholder={t(
              'l.payments.view.request_payment_modal.deposit_account_label',
              'Select deposit account'
            )}
            disabled
          />
        </Group>
      </Row>
    )

  return (
    <Row>
      <Group>
        <FieldDropdown
          id="deposit_account"
          name="deposit_account"
          placeholder={t(
            'l.payments.view.request_payment_modal.deposit_account_label',
            'Select deposit account'
          )}
          defaultValue={accounts[0]}
          options={accounts}
          required={isRequired}
        />
      </Group>
    </Row>
  )
}

export default DepositAccountField
